import { atom } from "jotai";

import type {
  IQuestionRateSummaryRes,
  IQuestionDetailRes,
  IUserMatchListRes,
  ICategoryListRes,
  IQuestionListRes,
  IUserTestListRes,
  IFeedbackListRes,
  IUserDetailRes,
  IUserListRes,
  TLanguage,
} from "@/src/services/type";
import {
  getCurrentLanguage,
  staticTranslate,
} from "@/src/helpers/localeHelper";

import type { IDynamicModalAtom } from "./type";

// global
export const xAtom = atom("X");
export const languageAtom = atom<TLanguage>(getCurrentLanguage());
export const localeMessageAtom = atom<Record<string, string>>({});

// user
export const userListAtom = atom<{
  data: IUserListRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });

// question
export const questionListAtom = atom<{
  data: IQuestionListRes["data"] | undefined;
  meta: IQuestionListRes["meta"] | undefined;
  loader: boolean;
}>({ data: undefined, meta: undefined, loader: true });
export const questionDetailAtom = atom<{
  data: IQuestionDetailRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });
export const questionRateSummaryAtom = atom<{
  data: IQuestionRateSummaryRes["data"] | undefined;
  meta: IQuestionRateSummaryRes["meta"] | undefined;
  loader: boolean;
}>({ data: undefined, meta: undefined, loader: true });
export const questionEditAtom = atom<{ loader: boolean }>({
  loader: false,
});

// user
export const userDetailAtom = atom<{
  data: IUserDetailRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });
export const userTestListAtom = atom<{
  data: IUserTestListRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });
export const userMatchListAtom = atom<{
  data: IUserMatchListRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });

// category
export const categoryListAtom = atom<{
  data: ICategoryListRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });

export const feedbackListAtom = atom<{
  data: IFeedbackListRes["data"] | undefined;
  loader: boolean;
}>({ data: undefined, loader: true });

// dynamic
export const dynamicLoaderAtom = atom(false);
export const dynamicModalAtom = atom<IDynamicModalAtom>({
  title: staticTranslate({ en: "Modal", tr: "Modal" }),
  visible: false,
  size: "md",
  layer: "",
});
